import { render, staticRenderFns } from "./ProjectImpact.vue?vue&type=template&id=6a1aea51&scoped=true&"
import script from "./ProjectImpact.vue?vue&type=script&lang=js&"
export * from "./ProjectImpact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1aea51",
  null
  
)

export default component.exports